"use client"
import Icon from '@ant-design/icons';
import type { GetProps } from 'antd';

type CustomIconComponentProps = GetProps<typeof Icon>;

const HotelsSvg = () => (
  <svg width="24" height="20" viewBox="0 0 24 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M9 7.5C9 7.99445 8.85338 8.4778 8.57867 8.88892C8.30397 9.30005 7.91352 9.62048 7.45671 9.8097C6.99989 9.99891 6.49723 10.0484 6.01227 9.95196C5.52732 9.8555 5.08186 9.61739 4.73223 9.26776C4.3826 8.91813 4.1445 8.47268 4.04804 7.98772C3.95157 7.50277 4.00108 7.0001 4.1903 6.54329C4.37952 6.08647 4.69995 5.69603 5.11107 5.42132C5.5222 5.14662 6.00555 5 6.5 5C7.16304 5 7.79893 5.26339 8.26777 5.73223C8.73661 6.20107 9 6.83696 9 7.5ZM24 10V8C24 6.93913 23.5786 5.92172 22.8284 5.17157C22.0783 4.42143 21.0609 4 20 4H15C13.9391 4 12.9217 4.42143 12.1716 5.17157C11.4214 5.92172 11 6.93913 11 8V10H24ZM2 12V1C2 0.734783 1.89464 0.480429 1.70711 0.292893C1.51957 0.105357 1.26522 0 1 0C0.734784 0 0.48043 0.105357 0.292893 0.292893C0.105357 0.480429 0 0.734783 0 1L0 19C0 19.2652 0.105357 19.5196 0.292893 19.7071C0.48043 19.8946 0.734784 20 1 20C1.26522 20 1.51957 19.8946 1.70711 19.7071C1.89464 19.5196 2 19.2652 2 19V17H22V19C22 19.2652 22.1054 19.5196 22.2929 19.7071C22.4804 19.8946 22.7348 20 23 20C23.2652 20 23.5196 19.8946 23.7071 19.7071C23.8946 19.5196 24 19.2652 24 19V12H2Z" fill="currentColor" />
  </svg>


)

const HotelsIcon = (props: Partial<CustomIconComponentProps>) => (
  <Icon component={HotelsSvg} {...props} />
);

export default HotelsIcon